import React, { useEffect } from 'react'
import PropTypes from 'prop-types'

const VIDEO_ID = 'teleport-jw-player-id'

const JwPlayer = ({ src, options: { image, autostart } }) => {
  useEffect(() => {
    window.jwplayer?.(VIDEO_ID).setup({
      file: src,
      image,
      autostart,
    })

    return () => {
      window.jwplayer?.().remove()
    }
  }, [src, image, autostart])

  return <div id={VIDEO_ID} />
}

JwPlayer.defaultProps = {
  options: {},
}

JwPlayer.propTypes = {
  src: PropTypes.string,
  options: PropTypes.object,
}

export default JwPlayer
